import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'
import { transformPagination } from '@hoxtonmix/utils'

export const groupService = service
  .enhanceEndpoints({ addTagTypes: ['Group'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      createGroup: builder.mutation<Res['group'], Req['createGroup']>({
        invalidatesTags: [{ id: 'LIST', type: 'Group' }],
        query: (query: Req['createGroup']) => ({
          body: query,
          method: 'POST',
          url: 'partners/groups/',
        }),
      }),
      deleteGroup: builder.mutation<Res['group'], Req['deleteGroup']>({
        invalidatesTags: [{ id: 'LIST', type: 'Group' }],
        query: (query: Req['deleteGroup']) => ({
          body: query,
          method: 'DELETE',
          url: `partners/groups/${query.id}`,
        }),
      }),
      getGroup: builder.query<Res['group'], Req['getGroup']>({
        providesTags: (req, _, res) => [{ id: res?.id, type: 'Group' }],
        query: (query: Req['getGroup']) => ({
          url: `partners/groups/${query.id}`,
        }),
      }),
      getGroups: builder.query<Res['groups'], Req['getGroups']>({
        providesTags: [{ id: 'LIST', type: 'Group' }],
        query: () => ({
          url: `partners/groups/?page_size=1000`,
        }),
        transformResponse: (res, _, req) =>
          transformPagination(req, res) as any,
      }),
      updateGroup: builder.mutation<Res['group'], Req['updateGroup']>({
        invalidatesTags: (req, _, res) => [
          { id: 'LIST', type: 'Group' },
          { id: res?.id, type: 'Group' },
        ],
        async queryFn(arg, _queryApi, _extraOptions, baseQuery) {
          const { toAdd, toRemove, toUpdate, users, ...rest } = arg
          await Promise.all(
            (toRemove || []).map((v) => {
              baseQuery({
                body: {},
                method: 'DELETE',
                url: `partners/groups/${rest.id}/members/${v.id}`,
              })
            }),
          )

          await Promise.all(
            (toUpdate || []).map((v) => {
              baseQuery({
                body: v,
                method: 'PUT',
                url: `partners/groups/${rest.id}/members/${v.id}`,
              })
            }),
          )

          if (toAdd?.length) {
            baseQuery({
              body: {
                users: toAdd.map((v) => ({ role: v.role, user_id: v.user_id })),
              },
              method: 'POST',
              url: `/partners/groups/${rest.id}/members`,
            })
          }

          const updateResult = await baseQuery({
            body: rest,
            method: 'PUT',
            url: `partners/groups/${rest.id}`,
          })

          return updateResult
        },
      }),
      // END OF ENDPOINTS
    }),
  })

export async function createGroups(
  store: any,
  data: Req['createGroup'],
  options?: Parameters<typeof groupService.endpoints.createGroup.initiate>[1],
) {
  return store.dispatch(
    groupService.endpoints.createGroup.initiate(data, options),
  )
}
export async function deleteGroups(
  store: any,
  data: Req['deleteGroup'],
  options?: Parameters<typeof groupService.endpoints.deleteGroup.initiate>[1],
) {
  return store.dispatch(
    groupService.endpoints.deleteGroup.initiate(data, options),
  )
}
export async function getGroups(
  store: any,
  data: Req['getGroups'],
  options?: Parameters<typeof groupService.endpoints.getGroups.initiate>[1],
) {
  return store.dispatch(
    groupService.endpoints.getGroups.initiate(data, options),
  )
}
export async function updateGroups(
  store: any,
  data: Req['updateGroup'],
  options?: Parameters<typeof groupService.endpoints.updateGroup.initiate>[1],
) {
  return store.dispatch(
    groupService.endpoints.updateGroup.initiate(data, options),
  )
}
// END OF FUNCTION_EXPORTS

export const {
  useCreateGroupMutation,
  useDeleteGroupMutation,
  useGetGroupQuery,
  useGetGroupsQuery,
  useUpdateGroupMutation,
  // END OF EXPORTS
} = groupService
